export default "__VITE_ASSET__yXjuVx$Q__"